import { LiliDrawer } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';

interface IProps {
  images: string[];
  visible: boolean;
  onHide: () => void;
}

export const InfoSideBar = ({ images, visible, onHide }: IProps) => {
  const { t } = useTranslation();

  return (
    <LiliDrawer
      visible={visible}
      onHide={onHide}
      modal={false}
      header={t('pages.verificationCenter.example')}
      wrapperClassName='overflow-y-scroll'
      className='sm:!w-1/2 !w-full'>
      <div className='flex flex-col gap-[22px] items-center p-6'>
        {images.map((image) => (
          <div
            key={image}
            className='w-full h-full flex flex-col items-center border-outline-primary-bw-03 rounded-sm'>
            <img
              src={image}
              alt='Document example'
              className='contain min-w-[300px] w-full max-w-[500px] h-full object-contain'
            />
          </div>
        ))}
      </div>
    </LiliDrawer>
  );
};
